"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = require("react");
const react_2 = require("@emotion/react");
const utils_1 = require("@masonweb/utils");
const navigation_1 = require("../navigation");
const context_1 = require("./context");
const hamberger_menu_1 = require("./hamberger-menu");
const universal_search_1 = require("../universal-search");
const LayoutInternals = ({ search, children }) => {
    const [{ height, navigationState }, setLayoutContextState] = (0, context_1.useLayoutContext)();
    const barRef = (0, react_1.useRef)(null);
    const [barHeight, setBarHeight] = (0, react_1.useState)(universal_search_1.UNIVERSAL_SEARCH_MAX_HEIGHT);
    (0, react_1.useEffect)(() => {
        const el = barRef.current;
        if (!el)
            return;
        const observer = new ResizeObserver(entries => {
            var _a;
            const h = (_a = entries[0]) === null || _a === void 0 ? void 0 : _a.contentRect.height;
            if (h)
                setBarHeight(h);
        });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: layoutCss, style: { "--height": height + "px", "--bar-height": barHeight + "px" } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, clsx_1.default)("hud-navigation", {
                    mobile: navigationState !== "desktop",
                    open: navigationState === "mobileViewOpen",
                }) }, { children: (0, jsx_runtime_1.jsx)(navigation_1.Navigation, {}) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, clsx_1.default)("hud-container", {
                    mobile: navigationState !== "desktop",
                    open: navigationState === "mobileViewOpen",
                }) }, { children: [(0, jsx_runtime_1.jsx)(hamberger_menu_1.HambergerMenu, { navigationState: navigationState, setLayoutContextState: setLayoutContextState }), search && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "hud-container-bar", ref: barRef }, { children: search })), (0, jsx_runtime_1.jsx)("main", { children: children })] }))] })));
};
const Layout = ({ search, children }) => {
    return (0, utils_1.isWindowInIframe)() ? children : ((0, jsx_runtime_1.jsx)(context_1.LayoutContextProvider, { children: (0, jsx_runtime_1.jsx)(LayoutInternals, Object.assign({ search: search }, { children: children })) }));
};
exports.Layout = Layout;
const layoutCss = (0, react_2.css) `
  width: 100%;
  background-color: #fafbfe;

  .hud-navigation {
    box-sizing: border-box;
    overflow: hidden;
    height: var(--height);
    max-height: var(--height);
    position: fixed;
    transition: width 400ms ease-in-out;

    width: 250px;

    background-color: #101b23;
    color: #fff;
    z-index: 3;

    &.mobile {
      width: 0;

      .hud-navigation-links {
        opacity: 0;
        transition: opacity 200ms ease-in;
      }

      &.open {
        width: 100vw;

        .hud-navigation-links {
          opacity: 1;
          transition: opacity 200ms 100ms ease-in;
        }
      }
    }
  }

  .hud-container {
    display: flex;
    flex-direction: column;
    margin-left: 250px;
    position: relative;

    &.mobile {
      margin-left: 0;

      .hud-container-bar {
        margin-left: 0;
      }
    }

    .hud-container-bar {
      top: 0;
      left: 0;
      right: 0;
      position: fixed;
      z-index: 2;
      margin-left: 250px;
    }

    > *:not(main) {
      flex: 0 0 auto;
    }
    > main {
      /* Use measured bar height instead of static constant */
      margin-top: var(--bar-height);
      flex: 1 1 0px;
    }
    .router-wrapper {
      width: 100%;
      position: relative;
      min-height: calc(var(--height) - var(--bar-height));
    }

    header {
      padding: 1rem;
    }

    footer {
      padding: 1rem;
    }
  }
`;
